import { ProtectedComponent } from '@components'

import { Button } from '@billy/design-system'
import Cookies from 'js-cookie'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'

import { CookieKeys } from '../../../../enums/cookieKeys'
import { EmberRoute } from '../../../../enums/emberRoute'
import { Scope } from '../../../../enums/scope'
import { useSegment } from '../../../../hooks'
import { useEmberRouteUrl } from '../../../../hooks/routing/useEmberRouteUrl'

export const QuotesSideActions = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { url: newQuoteUrl } = useEmberRouteUrl(EmberRoute.QuotesNew)
  const navigate = useNavigate()
  const location = useLocation()

  const handleCreateNewQuoteClick = useCallback(() => {
    track('XXX - Jesper - Action Taken', {
      context: 'quotes_list',
      action: 'create quote',
    })
    Cookies.set(CookieKeys.QuotesListQuery, location.search)

    if (newQuoteUrl) {
      navigate(newQuoteUrl)
    }
  }, [track, newQuoteUrl, navigate, location.search])

  return (
    <ProtectedComponent scopes={Scope.OfferWrite}>
      <Button variant="filled" icon="circlePlus" onClick={handleCreateNewQuoteClick}>
        {t('legacyQuotes.create_quote')}
      </Button>
    </ProtectedComponent>
  )
}
